export const ASSET_PAIRS = 'assetPairs';
export const AUTHENTICATION = 'authentication';
export const COMMENTS = 'comments';
export const CONNECT_FIVE = 'connectFive';
export const CURRENCIES = 'currencies';
export const EXCHANGE_ORDERS = 'exchangeOrders';
export const FOLLOWERS = 'followers';
export const FOLLOWINGS = 'followings';
export const FRONTEND_DEPLOYMENTS = 'frontendDeployments';
export const INVITATIONS = 'invitations';
export const INVITATION_LIMITS = 'invitationLimits';
export const MANAGER = 'manager';
export const MINTS = 'mints';
export const NOTIFICATIONS = 'notifications';
export const ORDER_BOOK = 'orderBook';
export const POSTS = 'posts';
export const SELF = 'self';
export const TRADES = 'trades';
export const TRADE_PRICE_CHART_DATA = 'tradePriceChartData';
export const USERS = 'users';
export const USER_STATS = 'userStats';
export const WALLETS = 'wallets';
export const WIRES = 'wires';
